module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/college-logos/univ-georgia-0e7dc9c17c8c21e1bc3e7b33da6e7a15.svg";